export default __webpack_public_path__ + "static/media/web-pages.ed6359c3.png";